import { createSelector } from '@ngrx/store';
import { TransactionDebitBaseState } from './transaction-debit-base.model';
import { FEATURE_NAME } from './transaction-debit-base.constant';
import {
  getTransactionGroupRangeKey,
  TransactionGroupBy,
  TransactionGroupRange
} from '@zerops/models/transaction-debit';
import {
  createTimeSeriesSelectors,
  createTimeSeriesSpecializedSelectors
} from '../shared';

// Create base time-series selectors using shared utilities
const baseSelectors = createTimeSeriesSelectors<TransactionDebitBaseState>(
  FEATURE_NAME,
  getTransactionGroupRangeKey
);

// Create specialized selectors with period costs
const allSelectors = createTimeSeriesSpecializedSelectors(
  baseSelectors,
  {
    periodCostsSelector: (state: TransactionDebitBaseState) => state.periodCosts
  }
);

// Export all selectors from shared utilities
export const selectTransactionDebitBaseState = allSelectors.selectBaseState;
export const selectTransactionDebitBaseGroupedData = allSelectors.selectGroupedData;
export const selectTrackedItems = allSelectors.selectTrackedItems;
export const selectPeriodCosts = allSelectors.selectPeriodCosts;
export const selectClientPeriodCosts = allSelectors.selectClientPeriodCosts;
export const selectProjectPeriodCostsMap = allSelectors.selectProjectPeriodCostsMap;
export const selectServicePeriodCostsMap = allSelectors.selectServicePeriodCostsMap;

// Transaction-debit specific selectors that map to shared patterns
export const selectTransactionDebitGroup = (
  groupBy: TransactionGroupBy,
  range: TransactionGroupRange
) => allSelectors.selectGroup(groupBy, range);

// Map transaction-debit specific names to shared selectors
export const selectProjectTransactionDebitGroupMap = createSelector(
  selectTransactionDebitBaseGroupedData,
  (data) => {
    // Transaction-debit uses 'Service' groupBy key
    if (!data || !data[TransactionGroupBy.Service]) { return undefined; }
    return data[TransactionGroupBy.Service];
  }
);

export const selectServiceTransactionDebitGroupInnerMap = createSelector(
  selectTransactionDebitBaseGroupedData,
  (data) => {
    // Transaction-debit uses 'Metric' groupBy key
    if (!data || !data[TransactionGroupBy.Metric]) { return undefined; }
    return data[TransactionGroupBy.Metric];
  }
);

export const selectClientTransactionDebitGroupMap = (
  groupRange: TransactionGroupRange
) => createSelector(
  selectTransactionDebitBaseGroupedData,
  (data) => {
    if (!data || !data[TransactionGroupBy.Project]) { return undefined; }
    return data[TransactionGroupBy.Project][getTransactionGroupRangeKey(groupRange.key)];
  }
);